module.exports = __webpack_public_path__ + "static/media/404.be283f63.jpg";